import gql from 'graphql-tag';
import { TRACKER_FRAGMENT } from './fragments';

export const trackerDeleteMutation = gql`
  mutation TrackerDeleteMutation($id: ID!) {
    deleteTracker(id: $id) {
      errors {
        path
        message
      }
    }
  }
`;

export const trackerCreateOrUpdateMutation = gql`
  mutation TrackerCreateOrUpdateMutation($input: CreateOrUpdateTrackerInput!) {
    createOrUpdateTracker(input: $input) {
      tracker {
        ...TrackerFields
      }
      errors {
        path
        message
      }
    }
  }
  ${TRACKER_FRAGMENT}
`;
